<template>
  <div>
    <v-card>
      <!-- 基本資訊 -->
      <v-toolbar>
        <v-toolbar-title>個人資料</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-container fluid>
          <v-row row>
            <v-col sm4 hidden-sm-and-down>
              <v-subheader>帳號</v-subheader>
            </v-col>
            <v-col sm8 xs12>
              <v-text-field
                name="input-1-5"
                label="帳號"
                value=""
                v-model="profile.account"
                single-line
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row row>
            <v-col sm4 hidden-sm-and-down>
              <v-subheader>姓名</v-subheader>
            </v-col>
            <v-col sm8 xs12>
              <v-text-field
                name="input-4-5"
                label="姓名"
                value=""
                v-model="profile.name"
                single-line
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row row>
            <v-col sm4 hidden-sm-and-down>
              <v-subheader>聯絡電話</v-subheader>
            </v-col>
            <v-col sm8 xs12>
              <v-text-field
                name="input-5-5"
                label="聯絡電話"
                value=""
                class="input-group--focused"
                v-model="profile.phone"
                single-line
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>

        <v-card-row actions class="mt-4">
          <v-btn small primary dark v-on:click.native="link('https://www.liveabc.com/site/online_store/member/log2.asp')">編輯</v-btn>
        </v-card-row>
      </v-card-text>
    </v-card>

    <v-container fluid>
      <v-row row>
        <v-col xs12 sm4 class="mt-3">
          <v-card class="white--text primary">
            <v-card-row>
              <v-card-title>
                使用期限
              </v-card-title>
            </v-card-row>
            <v-card-row>
              <v-card-text>
                <h5 class="white--text hidden-sm-and-down" style="text-align: center;">{{ this.profile.expiredTime ? this.profile.expiredTime : '&nbsp;' }}</h5>
                <h3 class="white--text hidden-md-and-up" style="text-align: center;">{{ this.profile.expiredTime ? this.profile.expiredTime : '&nbsp;' }}</h3>
              </v-card-text>
            </v-card-row>
            <v-card-row actions>
              <v-btn icon dark router href="/user/period">
                <v-icon>search</v-icon>
              </v-btn>
            </v-card-row>
          </v-card>
        </v-col>

        <v-col xs12 sm4 class="mt-3">
          <v-card class="white--text primary">
            <v-card-row>
              <v-card-title>
                金幣餘額
              </v-card-title>
            </v-card-row>
            <v-card-row>
              <v-card-text>
                <h5 class="white--text hidden-sm-and-down" style="text-align: center;">{{ this.profile.goldCount }} 個</h5>
                <h3 class="white--text hidden-md-and-up" style="text-align: center;">{{ this.profile.goldCount }} 個</h3>
              </v-card-text>
            </v-card-row>
            <v-card-row actions>
              <v-btn icon dark router href="/user/coin">
                <v-icon>search</v-icon>
              </v-btn>
            </v-card-row>
          </v-card>
        </v-col>

        <v-col xs12 sm4 class="mt-3">
          <v-card class="white--text primary">
            <v-card-row>
              <v-card-title>
                &nbsp;
              </v-card-title>
            </v-card-row>
            <v-card-row>
              <v-card-text>
                <h5 class="white--text hidden-sm-and-down" style="text-align: center;">&nbsp;</h5>
                <h3 class="white--text hidden-md-and-up" style="text-align: center;">&nbsp;</h3>
              </v-card-text>
            </v-card-row>
            <v-card-row actions>
              <v-btn icon dark>
                &nbsp;
              </v-btn>
            </v-card-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  // import api from '../api'
  import { mapActions } from 'vuex'

  export default {

    name: 'MyProfile',

    data () {
      return {
        profile: {
          account: '',
          name: '',
          phone: ''
        }
      }
    },

    mounted () {
      this.getProfile()
      this.$nextTick(() => {
        this.profile.account = this.$store.getters.user.UserName
        this.profile.name = this.$store.getters.user.RealName
        this.profile.phone = this.$store.getters.user.Phone
        this.profile.goldCount = this.$store.getters.user.GoldCount
        this.profile.pointCount = this.$store.getters.user.PointCount
        this.profile.purchasedCount = this.$store.getters.user.PurchasedCount
        this.profile.expiredTime = this.$store.getters.user.ExpiredTime
      })
    },

    methods: {
      ...mapActions([
        'getProfile'
      ]),

      link (url) {
        window.open(url, '_blank')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// MyProfile.vue?372fbf70